jQuery(function ($) {
	var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
		bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

	$(window).scroll(function () {
		var data = {
			'action': 'loadmore',
			'query': misha_loadmore_params.posts,
			'page': misha_loadmore_params.current_page
		};

		if ($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded == true) {
			$.ajax({
				url: misha_loadmore_params.ajaxurl,
				data: data,
				type: 'GET',
				beforeSend: function (xhr) {
					// you can also add your own preloader here
					// you see, the AJAX call is in process, we shouldn't run it again until complete
					canBeLoaded = false;
				},
				success: function (data) {

					if (data) {

						data = JSON.parse(data);

						if (data.has_more) {
							$(".result-list").append(data.content);
							canBeLoaded = true; // the ajax is completed, now we can run it again
							//if(parseInt(data.results) == 1) {
							//  updateStatusMessageAjax("#status-result", "Se encontró 1 resultado");
							//} else {
							//  updateStatusMessageAjax("#status-result", "Se encontraron "+data.results+" resultados");  
							//}
						} else {
							//updateStatusMessageAjax("#status-result", "No se encontraron resultados para la búsqueda", 'highlighted-warning');  
							//content_result.html( "" );
							canBeLoaded = false; // the ajax is completed, now we can run it again
						}

						$(".misha_loadmore").remove();
						$(".load_more_container").before(data.content);
						//$('#main').find('article:last-of-type').after( data ); // where to insert posts

						misha_loadmore_params.current_page++;
					}
				}
			});
		}
	});

	// load more button click event
	$('.btn_more_comments').click(function () {
		var button = $(this);

		// decrease the current comment page value
		cpage--;

		$.ajax({
			url: ajaxurl, // AJAX handler, declared before
			data: {
				'action': 'cloadmore', // wp_ajax_cloadmore
				'post_id': parent_post_id, // the current post
				'cpage': cpage, // current comment page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				button.text('Cargando...'); // preloader here
			},
			success: function (data) {
				if (data) {
					$('ul.lista_comentarios').append(data);
					button.text('Ver 5 más ↓');
					// if the last page, remove the button
					if (cpage == 1)
						button.remove();
				} else {
					button.remove();
				}
			}
		});
		return false;
	});
});